import {of, empty} from 'rxjs';
import {map, concatMap, exhaustMap, catchError, delay, filter} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import Http from '../../http/http';
import AppSettings from '../../app.settings';
import * as TransferActions from './transfer.actions';
import * as AssetActions from '../assets/assets.action';
import * as SearchActions from '../search/search.action';
import {TransferStatusEnum} from './transfer.reducer';

export const GetAccountTransferKeys = action$ =>
  action$.pipe(
    ofType(TransferActions.GET_TRANSFERKEYS),
    concatMap(() =>
      Http.get(`${AppSettings.IcebergApiTransfersEndpoint}/keys`).pipe(
        map(data => TransferActions.getTransferKeysSuccess(data)),
        catchError(error => of(TransferActions.getTransferKeysFail(error)))
      )
    )
  );

export const InitiateAssetTransfer = action$ =>
  action$.pipe(
    ofType(TransferActions.INITIATE_ASSET_TRANSFER),
    concatMap(action =>
      Http.post(`${AppSettings.IcebergApiInstallationsEndpoint}/installations/_filter`, {
        criteria: {
          equipmentIds: action.payload.assets.map(asset => asset.id)
        }
      }).pipe(
        map(response => TransferActions.transferAssets(action.payload.key, response)),
        catchError(error => of(TransferActions.initiateAssetTransferFail(error)))
      )
    )
  );

export const TransferAssets = action$ =>
  action$.pipe(
    ofType(TransferActions.TRANSFER_ASSETS),
    exhaustMap(action => {
      const transferResource = action.payload.installations.map(install => ({
        key: action.payload.key,
        href: install.href,
        id: install.id
      }));
      return of(...transferResource).pipe(
        delay(250),
        concatMap(installation =>
          Http.post(`${AppSettings.IcebergApiTransfersEndpoint}/transfers`, {
            key: {key: action.payload.key},
            resource: {href: installation.href}
          }).pipe(
            map(() => TransferActions.transferAssetSuccess(installation.id)),
            catchError(error => of(TransferActions.transferAssetFail(installation.id, error)))
          )
        )
      );
    })
  );

//after all transfers done => update deselect transferd assets the refresh the data
export const AfterTransferAssets = (action$, store$) =>
  action$.pipe(
    ofType(TransferActions.TRANSFER_ASSET_FAIL, TransferActions.TRANSFER_ASSET_SUCCESS),
    filter(() => store$.value.transfer.transferStatus !== TransferStatusEnum.TRANSFERRING),
    concatMap(() => {
      const {assets, transfer} = store$.value;
      const {selections = []} = assets;
      const {transferAssets = []} = transfer;

      const successTransferAssetsIds = transferAssets
        .filter(transfer => transfer.status === TransferStatusEnum.SUCCESS)
        .map(transfer => transfer.id);

      // remove transferrd assets from the selections
      const newSelections = selections.filter(asset => !successTransferAssetsIds.includes(asset.id));
      return successTransferAssetsIds.length > 0
        ? of(AssetActions.select(newSelections), SearchActions.refresh())
        : empty();
    })
  );
